import { render, staticRenderFns } from "./help01.vue?vue&type=template&id=0ccb7878&"
import script from "./help01.vue?vue&type=script&lang=js&"
export * from "./help01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports